import { Request } from '../request';

// Ops admin: read a single provider's outstanding listing-fee balance to decide whether to
// show a confirmation before Re-list. Uses admin-token (auto-injected for /admin-server/ urls).
export const getAdminProviderListingOverdue = (providerId: number) =>
    Request.get({
        url: `/admin-server/provider/billing/${providerId}/listing-overdue`,
        disableErrorNote: true,
    });
